export default "__VITE_PUBLIC_ASSET__5d22a396__"